import { tw } from '@ds/utils/tailwind'

const MAIN_IMG_DESKTOP_SIZE = '448px'

export const MAIN_IMG_SIZES = `(max-width: 768px) calc(80vw-26px), (max-width: 1024px) 328px, ${MAIN_IMG_DESKTOP_SIZE}`

const SMALL_ITEM_DESKTOP_SIZE = '104px'

export const ALT_IMG_SIZES_LARGE = `(max-width: 768px) calc(80vw-26px), ${SMALL_ITEM_DESKTOP_SIZE}`
export const ALT_IMG_SIZES_SMALL = `(max-width: 768px) calc(40vw-13px), ${SMALL_ITEM_DESKTOP_SIZE}`

export const CAROUSEL_MAX_HEIGHT_CLASS = tw`!max-h-[var(--carousel-max-size)]`
export const SQUARE_CLASS = tw`aspect-square`
// On md+, alt thumbnails unify to the small size
export const ALT_MD_SMALL_ALL_CLASS = tw`md:h-[var(--carousel-small-item-size)] md:w-[var(--carousel-small-item-size)] md:!max-h-[var(--carousel-small-item-size)] md:!max-w-[var(--carousel-small-item-size)]`

export const BIG_ITEM_SIZE_CLASS = tw`${SQUARE_CLASS} !h-[var(--carousel-big-item-size)] !w-[var(--carousel-big-item-size)] !max-w-[var(--carousel-max-size)] ${CAROUSEL_MAX_HEIGHT_CLASS}`
export const SMALL_ITEM_SIZE_CLASS = tw`${SQUARE_CLASS} !h-[var(--carousel-small-item-size)] w-[var(--carousel-small-item-size)] !max-h-[var(--carousel-small-item-max-size)] !max-w-[var(--carousel-small-item-max-size)]`
// Alt items: big vs small on mobile; all 104px (small) from md and up
export const BIG_ALT_ITEM_SIZE_CLASS = tw`${SQUARE_CLASS} !h-[var(--carousel-big-item-size)] w-[var(--carousel-big-item-size)] !max-h-[var(--carousel-big-item-max-size)] !max-w-[var(--carousel-big-item-max-size)] ${ALT_MD_SMALL_ALL_CLASS}`
export const SMALL_ALT_ITEM_SIZE_CLASS = tw`${SQUARE_CLASS} !h-[var(--carousel-small-item-size)] w-[var(--carousel-small-item-size)] !max-h-[var(--carousel-small-item-max-size)] !max-w-[var(--carousel-small-item-max-size)] ${ALT_MD_SMALL_ALL_CLASS}`
